import useDevice from '@/hooks/useDevice';
import { Link } from 'react-router-dom';

export interface NavbarButtonProps {
  to: string;
  title: string | React.ReactNode;
  isActive: boolean;
  activeTextColor: string;
  backColor: string;
  inactiveTextColor?: string;
  onClick?: () => void;
}

const NavbarItem: React.FC<NavbarButtonProps> = ({
  to,
  title,
  isActive,
  onClick = undefined,
  activeTextColor: activeBackColor,
  backColor: deactiveBackColor,
  inactiveTextColor
}) => {
  const { isDesktop } = useDevice();
  const activeBackgroundColor = isDesktop() ? '#fff' : activeBackColor;
  const activeTextColor = isDesktop() ? activeBackColor : '#fff';

  return (
    <Link
      to={to}
      type="button"
      onClick={onClick}
      className="text-base font-bold my-2 lg:my-0 border-0 home-body-nav-btn inline-flex justify-center items-center"
      style={{ backgroundColor: isActive ? activeBackgroundColor : deactiveBackColor }}
    >
      {typeof title === 'string'
        ? <span style={{ color: isActive ? activeTextColor : inactiveTextColor }}>{title}</span>
        : title
      }
    </Link>
  );
};

export default NavbarItem;
